(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["breadcrumb"] && !Shopify.designMode) return;
  try {
    (function () {
    const params = new URLSearchParams(window.location.search);
    const fromCollection = params.get('from_collection');
    if (!fromCollection) return;

    const nav = document.querySelector('nav[data-breadcrumb-collections]');
    if (!nav) return;

    const jsonEl = nav.querySelector('script[data-breadcrumb-collections-json]');
    if (!jsonEl) return;

    let collections;
    try {
      collections = JSON.parse(jsonEl.textContent);
    } catch {
      return;
    }

    const match = collections.find((c) => c.handle === fromCollection);
    if (!match) return;

    const link = nav.querySelector('[data-breadcrumb-collection-link]');
    const nameEl = nav.querySelector('[data-breadcrumb-collection-name]');
    if (link) link.setAttribute('href', match.url);
    if (nameEl) nameEl.textContent = match.title;
  })();
  } catch(e) { console.error(e); }
})();

})();
